import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataService } from 'src/app/shared/data.service';
import { AuthService } from 'src/app/auth/auth.service';
import { Router } from '@angular/router';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';
import { UtilsService } from 'src/app/shared/utils.service';

@Component({
    selector: 'app-reference-details',
    templateUrl: './reference-details.component.html',
    styleUrls: ['./reference-details.component.scss'],
    standalone: false
})
export class ReferenceDetailsComponent implements OnInit {
  reference: any;
  usedOnMobile: any;
  productId: any;
  constructor(public dialogRef: MatDialogRef<ReferenceDetailsComponent>,
              private dataService: DataService,
              public authService: AuthService,
              public utils: UtilsService,
              private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any,
              private router: Router) {
                this.productId = router.routerState.snapshot.root.children[0].children[0].params.id;
                this.reference = this.data.reference;
              }

  ngOnInit(): void {
    this.dataService.get('product/references/RetrieveReferenceById/' + this.productId + '/' + this.reference.id).then((data: any) => {
      if (data.statusCode === 200) {
        this.reference = data.data;
      }
    });
  }

  closeDialog() {
    this.dialog.closeAll();
  }

  usedOnMobileToggle(event: any) {
    this.usedOnMobile = event.source.checked;
    const payload = {
      productId: parseInt(this.productId.toString(), 10),
      referenceId: parseInt(this.reference.id.toString(), 10),
      usedOnMobile: this.usedOnMobile
    };
    this.dataService.put('product/references/UpdateUsedOnMobile', payload).then((data: any) => {
      if (data.statusCode === 200) {
        this.dialogRef.close(payload);
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Success',
            type: 'Success',
            message: 'Used on mobile updated successfully',
            buttonText: 'Ok'
          }
        });
      } else {
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Error',
            type: 'Error',
            message: 'Something went wrong, Please try again!',
            buttonText: 'Ok'
          }
        });
      }
    });
  }

}
